<template>
  <ul class="list-style">
    <li v-for="item in items">
      <div>
        <span class="text-gray">{{ item.item.part_number }}</span>
      </div>
      <div v-if="item.item.description">{{ item.item.description }}</div>
      <div class="flex-row-between font-12">
        <span
          >单价：￥{{ item.price }}

          <span class="text-gray"
            >({{ priceIncreasePercent(item.item.price, item.price) }}%)</span
          >
        </span>
        <span>数量：{{ item.count }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
import { numberMul, formatTime, priceIncreasePercent } from '@/util/index'

export default {
  props: {
    items: Array,
  },
  data() {
    return { priceIncreasePercent }
  },
}
</script>